import { colors } from './colors.theme'

const { white, grayLight } = colors

export const avatarTheme = {
  root: {
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 1,
    color: `${white} !important`,
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    background: grayLight,
    '&.extra-large': {
      width: 200,
      height: 200,
      fontSize: 72,
    },
  },
}
